import { FileText, PenLine, Receipt, Type } from 'lucide-react';
import type { Tool } from '@/registry/types';
import { InvoiceGenerator } from './InvoiceGenerator';
import { SignaturePad } from './SignaturePad';
import { ExpenseTracker } from './ExpenseTracker';
import { TextToSignature } from './TextToSignature';

export const operationsTools: Tool[] = [
  {
    id: 'invoice-generator',
    name: 'Invoice generator',
    category: 'operations',
    description: 'Composable invoice with auto-totals, tax, and PDF export.',
    keywords: ['invoice', 'bill', 'pdf', 'tax', 'gst'],
    icon: FileText,
    component: InvoiceGenerator,
    featured: true,
    inBrowser: true,
  },
  {
    id: 'signature-pad',
    name: 'Signature pad',
    category: 'operations',
    description: 'Draw and export a signature as transparent PNG.',
    keywords: ['signature', 'sign', 'draw', 'pen'],
    icon: PenLine,
    component: SignaturePad,
    inBrowser: true,
  },
  {
    id: 'text-to-signature',
    name: 'Text to signature',
    category: 'operations',
    description: 'Type a name → styled handwritten signature in 10 cursive fonts.',
    keywords: ['signature', 'sign', 'cursive', 'handwriting', 'name', 'text', 'autograph'],
    icon: Type,
    component: TextToSignature,
    featured: true,
    badge: 'new',
    inBrowser: true,
  },
  {
    id: 'expense-tracker',
    name: 'Expense tracker',
    category: 'operations',
    description: 'Log expenses, categorize, and export CSV.',
    keywords: ['expense', 'receipt', 'spending', 'budget'],
    icon: Receipt,
    component: ExpenseTracker,
    inBrowser: true,
  },
];
